import React from "react";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import TopicStringBlock from "../Components/IntroBlock.js";
import StringOutput from "../Components/StringOutput.js";
import "../Styles/Home.css";
import Tables from "../Components/Tables.js";

const HomePage = ({generatedData}) => {
    return (
        <div className="app-container">
            <Header />
            <div className="page-body-container">
                <TopicStringBlock />
                <StringOutput />
                <Tables generatedData={generatedData} />
            </div>
            <Footer />
        </div>
    );
}

export default HomePage;
export { HomePage as TopicTester };